import { z } from "zod";

const secedeICafeItemSchema = z.object({
  iCafeId: z.string(),
  secedeTypeCode: z.number(),
  executionStatusCode: z.number(),
  errorCode: z.string().optional(),
});

export const secedeICafeListSchema = z.array(secedeICafeItemSchema);

export type SecedeICafeListType = z.infer<typeof secedeICafeListSchema>;
